var map = {
	"./0.svg": 2429,
	"./1.svg": 5068,
	"./10.svg": 9972,
	"./11.svg": 2581,
	"./12.svg": 710,
	"./13.svg": 4535,
	"./14.svg": 5352,
	"./15.svg": 745,
	"./16.svg": 9370,
	"./17.svg": 6091,
	"./18.svg": 2924,
	"./19.svg": 2397,
	"./2.svg": 4095,
	"./20.svg": 6173,
	"./21.svg": 1900,
	"./22.svg": 4575,
	"./23.svg": 1998,
	"./24.svg": 7281,
	"./25.svg": 5040,
	"./26.svg": 179,
	"./27.svg": 2242,
	"./28.svg": 5733,
	"./29.svg": 100,
	"./3.svg": 9454,
	"./30.svg": 5154,
	"./31.svg": 9379,
	"./32.svg": 8640,
	"./33.svg": 5553,
	"./34.svg": 3726,
	"./35.svg": 1663,
	"./36.svg": 8988,
	"./37.svg": 4445,
	"./38.svg": 8698,
	"./39.svg": 3963,
	"./4.svg": 1009,
	"./40.svg": 2131,
	"./41.svg": 3138,
	"./42.svg": 4033,
	"./43.svg": 1232,
	"./44.svg": 3439,
	"./45.svg": 8686,
	"./46.svg": 7805,
	"./47.svg": 8092,
	"./48.svg": 5739,
	"./49.svg": 6682,
	"./5.svg": 6624,
	"./50.svg": 4704,
	"./51.svg": 6945,
	"./52.svg": 1906,
	"./53.svg": 9843,
	"./54.svg": 1564,
	"./55.svg": 5837,
	"./56.svg": 1662,
	"./57.svg": 4239,
	"./58.svg": 1464,
	"./59.svg": 9385,
	"./6.svg": 7635,
	"./60.svg": 7833,
	"./61.svg": 2472,
	"./62.svg": 6891,
	"./63.svg": 3018,
	"./64.svg": 197,
	"./65.svg": 2948,
	"./66.svg": 7399,
	"./67.svg": 8422,
	"./68.svg": 5953,
	"./69.svg": 1568,
	"./7.svg": 3906,
	"./70.svg": 5134,
	"./71.svg": 1535,
	"./72.svg": 9212,
	"./73.svg": 7757,
	"./74.svg": 3826,
	"./75.svg": 7139,
	"./76.svg": 1392,
	"./77.svg": 2513,
	"./78.svg": 5094,
	"./79.svg": 8311,
	"./8.svg": 5253,
	"./80.svg": 1999,
	"./81.svg": 4062,
	"./82.svg": 4781,
	"./83.svg": 9324,
	"./84.svg": 9715,
	"./85.svg": 5490,
	"./86.svg": 5889,
	"./87.svg": 8976,
	"./88.svg": 4183,
	"./89.svg": 7734,
	"./9.svg": 4356,
	"./90.svg": 9148,
	"./91.svg": 7693,
	"./92.svg": 5598,
	"./93.svg": 8175,
	"./94.svg": 704,
	"./95.svg": 5505,
	"./96.svg": 3762,
	"./97.svg": 6803,
	"./98.svg": 9764,
	"./99.svg": 4693
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5305;